import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="relative bg-navy-900 text-white min-h-[80vh] flex items-center pt-28 pb-32 overflow-hidden" data-testid="hero-section">
      {/* Subtle radial highlight */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[1100px] h-[1100px] rounded-full bg-pink-500/[0.06] blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="h-[1px] w-10 bg-pink-400/70"></div>
            <span className="text-pink-400 font-semibold tracking-[0.3em] text-xs uppercase">Prosperity Funding</span>
            <div className="h-[1px] w-10 bg-pink-400/70"></div>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl xl:text-[88px] font-serif font-medium leading-[1.05] mb-8" data-testid="hero-headline">
            Capital funding that <span className="font-bold italic">fuels growth</span>
          </h1>

          <p className="text-lg lg:text-xl text-gray-300 mb-12 leading-relaxed max-w-2xl mx-auto" data-testid="hero-subhead">
            Smart bank financing and transparent funding solutions, built for the small and
            medium businesses that drive the real economy forward.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={() => navigate('/contact')}
              className="bg-white text-navy-900 px-8 py-3.5 rounded-full font-bold hover:bg-pink-500 hover:text-white transition-all duration-300 flex items-center gap-2 group"
              data-testid="hero-cta-apply-btn"
            >
              Get funded today
              <ArrowRight size={18} className="text-pink-500 group-hover:text-white transition-colors" />
            </button>
            <button
              onClick={() => navigate('/about')}
              className="px-8 py-3.5 rounded-full font-bold border border-gray-500 hover:border-pink-500 hover:text-pink-500 transition-all duration-300 flex items-center gap-2"
              data-testid="hero-cta-about-btn"
            >
              About us
              <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>

      {/* Wave Divider at Bottom */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none rotate-180">
        <svg className="relative block w-full h-[100px] lg:h-[150px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" style={{ display: 'block', marginBottom: '-1px' }}>
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-white"></path>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
